/**
 * roundMaterials.js — IDI-178 placeholder material-quantity rounding.
 *
 * Background. Legacy carried a per-quote "Round Materials" Yes/No toggle
 * (Quote_RoundMaterials) that controlled whether material quantity
 * calculations rounded to a whole unit before pricing. BIDIT 2.0 migrated
 * the field onto quotes (`roundMaterials`, confirmed live: ~48% of tenant
 * 270's quotes carry it) but never read or wrote it anywhere — the toggle
 * simply didn't exist in the UI and had zero effect on pricing.
 *
 * This module is an explicit PLACEHOLDER for the real rounding rule. The
 * legacy behavior almost certainly rounds material QUANTITY to a whole
 * coverage unit (e.g. whole bags/rolls/boards), not the raw square footage
 * — but that requires real per-product coverage-rate data
 * (coverage_per_set / coverage_rvalues_*), which is NOT consumed anywhere
 * in the live quote calculation today (see seedCatalog.js buildLineItem —
 * those fields only exist in the Settings admin editor, ItemCoveragePanel.js).
 *
 * Placeholder rule (2026-08-31): round the entered sqft UP to the next
 * whole square foot. Replace applyRoundMaterials's body once real
 * per-product coverage data flows into buildLineItem, and update this
 * file's tests to match — the call sites (AddItemCascade.js) should not
 * need to change.
 */

/**
 * @param {number} sqft - raw entered square footage
 * @param {boolean} roundMaterials - the quote-level toggle state
 * @returns {number} sqft, rounded up to the next whole square foot when
 *   roundMaterials is true; unchanged otherwise.
 */
export function applyRoundMaterials(sqft, roundMaterials) {
  const n = Number(sqft);
  if (!Number.isFinite(n)) return sqft;
  if (!roundMaterials) return n;
  return Math.ceil(n);
}
